module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-heart-fill-fbe60b62.svg";